import { ROUTES } from "@/App";

export const NEW_JOB_ID = "new";

export const jobPath = (jobId: string) =>
  ROUTES.DIRECT_JOB.replace(":jobId", jobId);
